import { getStore } from '@/utils/dva'
import { ActionType, SUPPORTED_ACTION_TYPES } from '@/modules/afterSale/constants/afterSalesOrderAction'

/**
 * 检查当前的操作类型是否支持异步处理退款
 *
 * 判断逻辑：
 * 1. 用户是否在批量处理售后单 异步任务化 白名单；
 * 2. 当前操作类型是否支持异步处理退款；
 *
 * 影响点：
 * 1. 对应操作类型不限制勾选的售后单条数；
 * 2. 对应操作类型不限制售后单必须为同一店铺；
 */
export function allowAsyncProcessingRefund(actionType: ActionType | undefined) {
    const isInAsyncTaskWhitelist = getStore().getState()?.menu?.userMenuWhiteList?.AFTER_SALES_RETURN_ASYNC_WHITELIST
    if (!isInAsyncTaskWhitelist) {
        return false
    }
    return actionType ? SUPPORTED_ACTION_TYPES.includes(actionType) : false
}
